import React, { Fragment } from 'react';
import { useState } from 'react';
import { Button, Icon, Modal } from 'antd';
import _get from 'lodash/get';

import Coins from '../../components/Coins';
import IconToolTip from '../../components/IconToolTip';
import { COIN_ICONS, MISSING_ICON, CURRENCY_SYMBOL, CLOUD_PLAN_CRYPTO_PRO_FIAT_RAMP } from '../../config/media';
import RemoveConfirmation from '../CreateExchange/Confirmation';
import PairContainer from '../CreatePair/style';
import { Link } from 'react-router-dom';

const basicCoins = ["btc", "xht", "eth", "usdt"];

const Final = ({
    isPreview = false,
    isConfigure = false,
    coinFormData = {},
    handleBack,
    handleConfirmation,
    handleEdit = () => { },
    handleFileChange = () => { },
    setConfigEdit,
    handleDelete = () => { },
    user,
    handleScreenChange,
    handleWithdrawalEdit,
    exchange
}) => {
    let isUpdateRequired = false;
    if ((exchange && exchange.plan === 'basic' && !basicCoins.includes(coinFormData.symbol)) || (exchange && exchange.plan === 'crypto' && coinFormData.type !== 'blockchain')) {
        isUpdateRequired = true;
    }
    const { meta = {}, type } = coinFormData;
    const [isVisible, setIsVisible] = useState(false);

    const renderFees = () => {
        if (coinFormData.withdrawal_fees) {
            return Object.keys(coinFormData.withdrawal_fees).map((data, index) => {
                const key = coinFormData.withdrawal_fees[data];
                let label;
                if (data === 'eth') {
                    label = 'ERC20';
                } else if (data === 'bnb') {
                    label = 'BEP20';
                } else if (data === 'trx') {
                    label = 'TRC20';
                } else if (data === 'klay') {
                    label = 'Klaytn';
                } else if (data === 'matic') {
                    label = 'Polygon';
                } else if (data === 'sol') {
                    label = 'Solana';
                }
                return <div key={index}><b>{label}</b>: {_get(key, 'value')} {_get(key, 'symbol').toUpperCase()} <div>
                    <b className='ml-2'>Status:</b> <span className='ml-1'>{coinFormData.withdrawal_fees[data].active !==false ? 'Active' : 'Not Active'}</span>
                </div></div>
            });
        }
    }

    const handleMoveBack = () => {
        if (!coinFormData.active) {
            handleScreenChange('edit_withdrawal_fees');
        } else {
            handleBack(true);
        }
    };

    return (
        <Fragment>
            <div className="title">
                {isPreview || isConfigure
                    ? `Manage ${coinFormData.symbol}`
                    : 'Add Asset'
                }
            </div>
            {isUpdateRequired ?
                <div className="red-warning">
                    <div className="icon-wrapper">
                        <div className='image-crypto-fiat'>
                            <img className="fiat-icon" src={CLOUD_PLAN_CRYPTO_PRO_FIAT_RAMP} alt="new_coin" />
                        </div>
                    </div>
                    <div>
                        Only upgraded plans can freely add other digital assets. Visit the billing page and upgrade your exchange plan to either <Link className='link-content' to='/billing'>Crypto Pro</Link>, <Link className='link-content' to='/billing'>Fiat Ramp</Link> or <Link className='link-content' to='/billing'>Boost</Link>.
                    </div>
                </div>
                : (!isPreview && !isConfigure)
                    ? type === 'fiat'
                        ? (<div className="grey-warning">
                            <div className="icon-wrapper">
                                <img className="fiat-icon" src={CURRENCY_SYMBOL} alt="new_coin" />
                            </div>
                            <div>
                                <p>Since fiat currencies aren't on the blockchain they are the full responsibility of the exchange operator to managed for solvency.</p>
                                <p>In order to facilitate FIAT deposits and withdrawals a banking or payment system must be connected to your exchange.</p>
                            </div>
                        </div>)
                        : (<div className="grey-warning">
                            <div className="warning-text">!</div>
                            <div>
                                <div className="sub-title">Please check the details carefully.</div>
                                <div>To avoid delays it is important to take the time to review the accuracy of the details below</div>
                            </div>
                        </div>)
                    : null
            }
            <div className="preview-coin-container flex-column">
                <div className="preview-content preview-content-align">
                    {!isPreview && !isConfigure
                        ? <span className="preview-color-tip sub-title">
                            Color
                            <span className="line"></span>
                        </span>
                        : null
                    }
                    <Coins
                        nohover
                        large
                        small
                        fullname={coinFormData.fullname}
                        type={(coinFormData.symbol || '').toLowerCase()}
                        color={meta.color}
                    />
                    {isConfigure
                        ? <Fragment>
                            <div className="edit-content">
                                <b>Color: </b>{meta.color}
                            </div>
                            {/* {type !== 'blockchain' */}
                            <Button type="primary" onClick={() => setConfigEdit('edit-color')}>Edit</Button>
                            {/* : null
                            } */}
                            <div className="description-small">This will be viewed on your wallet and transaction history page</div>
                        </Fragment>
                        : null
                    }
                    {!isPreview && !isConfigure
                        ? <Fragment>
                            <span className="preview-symbol-tip sub-title">
                                <span className="line"></span>
                                Symbol
                            </span>
                            <span className="preview-name-tip sub-title">
                                <span className="line"></span>
                                Name
                            </span>
                        </Fragment>
                        : null
                    }
                </div>
                <div className="preview-content">
                    {isConfigure
                        // && type !== 'blockchain'
                        ? <Fragment>
                            {coinFormData.logo
                                ? <img
                                    src={
                                        coinFormData.logo.type ? MISSING_ICON
                                            : coinFormData.logo
                                                ? coinFormData.logo
                                                : COIN_ICONS[(coinFormData.symbol || '').toLowerCase()]
                                                    ? COIN_ICONS[(coinFormData.symbol || '').toLowerCase()]
                                                    : MISSING_ICON
                                    }
                                    alt="coins"
                                    className="icon-preview"
                                />
                                : <div className="icon-upload">
                                    <div className="file-container">
                                        <label>
                                            <Icon type="upload" style={{ fontSize: '94px', color: '#808080' }} />
                                            <input
                                                type="file"
                                                onChange={(e) => handleFileChange(e, 'logo')}
                                                name="logo"
                                            />
                                        </label>
                                    </div>
                                </div>
                            }
                        </Fragment>
                        : <img
                            src={
                                coinFormData.logo
                                    ? coinFormData.logo
                                    : COIN_ICONS[(coinFormData.symbol || '').toLowerCase()]
                                        ? COIN_ICONS[(coinFormData.symbol || '').toLowerCase()]
                                        : MISSING_ICON
                            }
                            alt="coins"
                            className="icon-preview"
                        />
                    }
                    {isConfigure
                        ? <Fragment>
                            <div className="edit-content">
                                <b>Icon: </b>{coinFormData.iconName}
                            </div>
                            {/* {type !== 'blockchain' */}
                            <div className="icon-upload">
                                <div className="file-container">
                                    <label>
                                        <div className="upload-box">Upload</div>
                                        <input
                                            type="file"
                                            onChange={(e) => handleFileChange(e, 'logo')}
                                            name="logo"
                                        />
                                    </label>
                                </div>
                            </div>
                            {/* : null
                            } */}
                            <div className="description-small">Icon will be used in various trading related pages</div>
                        </Fragment>
                        : null
                    }
                    {!isPreview && !isConfigure
                        ? <span className="preview-icon-tip sub-title">
                            <span className="line"></span>
                            Icon
                        </span>
                        : null
                    }
                </div>
            </div>
            <div className="preview-detail-container">
                <div className="title">Asset info</div>
                <div><b>Name:</b> <span className='sub-txt'>{coinFormData.fullname}</span></div>
                <div><b>Symbol:</b><span className='sub-txt'> {(coinFormData.symbol || '').toUpperCase()}</span></div>
                <div className="type-wrap">
                    <div className="warning-container">
                        <b>Type: </b><span className='sub-txt'>{coinFormData.type}</span>
                        {/* {(!meta.is_blockchain
                        && !meta.is_fiat)
                        ? ' Virtual'
                        : meta.is_fiat
                            ? ' Fiat'
                            : ' Vault'
                    } */}
                        {isPreview && !coinFormData.verified && (coinFormData.created_by === user.id)
                            ? <IconToolTip
                                type="warning"
                                tip="This asset is in pending verification"
                                onClick={() => handleEdit(coinFormData)}
                            />
                            : null
                        }
                    </div>
                </div>
                {coinFormData.network
                    ? <div><b>Network:</b><span className='sub-txt'> {coinFormData.network}</span></div>
                    : null
                }
                {coinFormData.standard
                    ? <div><b>Standard:</b> <span className='sub-txt'>{coinFormData.standard}</span></div>
                    : null
                }
                {type === 'blockchain'
                    ? <div><b>Contract:</b><span className='sub-txt'> {coinFormData.contract}</span></div>
                    : null
                }
                {(!isConfigure)
                    ? <div><b>Color:</b> <span className='sub-txt'>{meta.color}</span></div>
                    : <div className="btn-wrapper">
                        <Button type="primary" onClick={() => setConfigEdit('edit-info')}>Edit</Button>
                    </div>
                }
            </div>
            <div className="preview-detail-container">
                <div className="title">Parameters</div>
                <div><b>Status:</b><span className='sub-txt'> {coinFormData.active ? 'Active' : 'Not active'}</span></div>
                {/* <div><b>Allow deposits:</b> {coinFormData.allow_deposit ? 'Enabled' : 'Disabled'}</div>
                <div><b>Allow withdrawal:</b> {coinFormData.allow_withdrawal ? 'Enabled' : 'Disabled'}</div> */}
                <div><b>Price:</b><span className='sub-txt'> {coinFormData.estimated_price}</span></div>
                <div><b>Fee for withdrawal:</b><span className='sub-txt'> {coinFormData.withdrawal_fee}</span></div>
                <div><b>Minimum withdrawal amount:</b> <span className='sub-txt'>{coinFormData.min}</span></div>
                <div><b>Maximum withdrawal amount:</b> <span className='sub-txt'> {coinFormData.max}</span></div>
                <div><b>Increment Amount:</b> <span className='sub-txt'> {coinFormData.increment_unit}</span></div>
                <div><b>Decimal points:</b><span className='sub-txt'>  {meta.decimal_points}</span></div>
                {isConfigure
                    // && type !== 'blockchain'
                    ? <div className="btn-wrapper">
                        <Button type="primary" onClick={() => setConfigEdit('edit-params')}>Edit</Button>
                    </div>
                    : null
                }
            </div>
            <div className="preview-detail-container">
                <div className="title">Withdrawal Fee</div>
                {coinFormData.withdrawal_fees
                    ?
                    <div>
                        <div>{renderFees()}</div>
                        {isConfigure ? (
                            <div className="btn-wrapper">
                                <Button
                                    className="green-btn"
                                    type="primary"
                                    onClick={handleWithdrawalEdit}
                                >
                                    Edit
                                </Button>
                            </div>
                        ) : null}
                    </div>
                    :
                    <div>
                        <b>{coinFormData.symbol}:</b><span className='sub-txt'> {coinFormData.withdrawal_fee}</span>
                    </div>
                }
            </div>
            {isPreview || isConfigure
                ? <div className="preview-detail-container">
                    <div className="title">Manage</div>
                    <div className="btn-wrapper">
                        <Button type="danger" onClick={() => setIsVisible(true)}>Remove</Button>
                        <div className="separator"></div>
                        <div className="description-small remove">Removing this coin will permanently delete this coin from your exchange and render any pairs using it inactive. Use with caution!</div>
                    </div>
                </div>
                : null
            }
            {!isPreview && !isConfigure
                ? <div className="btn-wrapper">
                    <Button className="green-btn" type="primary" onClick={handleMoveBack}>
                        Back
                    </Button>
                    <div className="separator"></div>
                    <Button type="primary" onClick={handleConfirmation} disabled={isUpdateRequired}>
                        Confirm
                    </Button>
                </div>
                : null
            }
            {isVisible ? <Modal visible={isVisible} footer={null} onCancel={() => setIsVisible(false)}>
                <PairContainer>
                    <RemoveConfirmation
                        onCancel={setIsVisible}
                        onHandleRemoveAsset={handleDelete}
                        removeCoin={coinFormData}
                        removeContent={'Assets'}
                    />
                </PairContainer>
            </Modal> : null}
        </Fragment>
    );
}

export default Final;
